module.exports = [{
      plugin: require('/Users/mateusz/Desktop/Projekty/Kontur/kontur/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"google":{"families":["Merriweather:400,300,300italic,400italic,700,700italic","Merriweather+Sans:400,700","Mukta Mahee:400,300,300italic,400italic,600,600italic,700,700italic","Open Sans:400,300,300italic,400italic,600,600italic,700,700italic"]}},
    },{
      plugin: require('/Users/mateusz/Desktop/Projekty/Kontur/kontur/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
